import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE, ACTIVE } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	Active = "active",
	Name = "name",
	OpenAndCloseType = "openAndCloseType",
	TaxiServices = "taxiServices",
	CreatedAt = "createdAt",
}

export const translationTablePath = "mainPage.accounts.schedules.columns.";

const accountsWorkShifts = makeTable({
	allIds: [
		ColumnId.Active,
		ColumnId.Name,
		ColumnId.OpenAndCloseType,
		ColumnId.TaxiServices,
		ColumnId.CreatedAt,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.Active,
		ColumnId.Name,
		ColumnId.OpenAndCloseType,
		ColumnId.TaxiServices,
		ColumnId.CreatedAt,
	],
	initialSortMethod: {
		column: ColumnId.CreatedAt,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.Active]: ACTIVE,
		[ColumnId.Name]: 624,
		[ColumnId.OpenAndCloseType]: 270,
		[ColumnId.TaxiServices]: 347,
		[ColumnId.CreatedAt]: DATE,
	},
	initialResizable: {
		[ColumnId.Active]: true,
		[ColumnId.Name]: true,
		[ColumnId.OpenAndCloseType]: true,
		[ColumnId.TaxiServices]: true,
		[ColumnId.CreatedAt]: true,
	},
	initialSortable: {
		[ColumnId.Active]: true,
		[ColumnId.Name]: true,
		[ColumnId.OpenAndCloseType]: true,
		[ColumnId.TaxiServices]: true,
		[ColumnId.CreatedAt]: true,
	},
});

export default accountsWorkShifts;
